import { createSelector } from 'reselect';
import { produce } from 'immer';
import {
  toPairs,
  fromPairs,
  compose,
  map,
  filter,
} from 'lodash/fp';

const mobileRegex = /^mobile/;
const instagramRegex = /^instagram/;
const feedRegex = /feed$/;

const getPlacementMap = state => state.adPlacement.placements;
export const getPlacement = id => createSelector(
  getPlacementMap,
  placementMap => placementMap.get(id),
);

export const getIsInstagramSelected = state => state.adPlacement.instagramSelected;

const extractName = ([name]) => name;
const extractValue = ([, value]) => value;
const getArrayPickedPlacements = createSelector(
  getPlacementMap,
  compose([
    map(extractName),
    filter(extractValue),
    Array.from,
  ]),
);

const initializeFBspec = (acc, el) => produce(acc, (draft) => {
  if (instagramRegex.test(el)) {
    draft.publisher_platforms.push('instagram');

    if (feedRegex.test(el)) {
      draft.instagram_positions.push('stream');
    } else {
      draft.instagram_positions.push('story');
    }
  } else if (mobileRegex.test(el)) {
    if (feedRegex.test(el)) {
      draft.facebook_positions.push('feed');
      draft.publisher_platforms.push('facebook');
      draft.device_platforms.push('mobile');
    } else {
      draft.publisher_platforms.push('audience_network');
    }
  } else {
    draft.publisher_platforms.push('facebook');
    draft.device_platforms.push('desktop');

    if (feedRegex.test(el)) {
      draft.facebook_positions.push('feed');
    } else {
      draft.facebook_positions.push('right_hand_column');
    }
  }
});


const extractUnique = ([key, placementArr]) => [key, [...new Set(placementArr)]];

const createFBspec = arr => arr.reduce(initializeFBspec, {
  facebook_positions: [],
  publisher_platforms: [],
  instagram_positions: [],
  device_platforms: [],
});

const emptySpecs = ([, value]) => value.length > 0;

export const getFBAdPlacementSpec = createSelector(
  getArrayPickedPlacements,
  compose([
    fromPairs,
    filter(emptySpecs),
    map(extractUnique),
    toPairs,
    createFBspec,
  ]),
);

export const getRGAdPlacementArray = createSelector(
  getPlacementMap,
  compose([
    map(extractValue),
    Array.from,
  ]),
);
